(function () {
  "use strict";

  if (window.__toaSellableStockBufferV1) return;
  window.__toaSellableStockBufferV1 = true;

  var BUFFER = Math.max(0, parseInt(window.TOA_SELLABLE_STOCK_BUFFER || "3", 10) || 0);
  var variantLimits = {};

  function parseInteger(value) {
    var text = String(value == null ? "" : value).trim();
    if (!/^-?\d+$/.test(text)) return null;
    var parsed = parseInt(text, 10);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function sellableLimit(rawLimit) {
    var parsed = parseInteger(rawLimit);
    if (parsed == null) return null;
    return Math.max(0, parsed - BUFFER);
  }

  function clampQuantity(value, limit) {
    var parsed = parseInteger(value);
    var fallback = limit > 0 ? 1 : 0;
    var quantity = parsed == null ? fallback : parsed;
    if (limit <= 0) return 0;
    return Math.max(1, Math.min(limit, quantity));
  }

  function variantIdForForm(form) {
    if (!form) return "";
    var field = form.querySelector('input[name="id"], select[name="id"]');
    return field ? String(field.value || "").trim() : "";
  }

  function actionIsCartAdd(value) {
    try {
      var url = new URL(value || "", window.location.origin);
      return /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(String(value || ""));
    }
  }

  function cartAddFormFromElement(element) {
    if (!element || !element.closest) return null;
    var form = element.closest('form[action*="/cart/add"]');
    if (form) return form;
    var card = element.closest(".toa-product-card-actions,.product-block__inner,.product-block,.product-details");
    return card ? card.querySelector('form[action*="/cart/add"]') : null;
  }

  function contextForAdjuster(adjuster) {
    return adjuster && adjuster.closest
      ? adjuster.closest(".toa-product-card-actions,.product-details,.product-block__inner,.product-block,form")
      : null;
  }

  function formForAdjuster(adjuster) {
    var form = adjuster && adjuster.closest ? adjuster.closest('form[action*="/cart/add"]') : null;
    if (form) return form;
    var context = contextForAdjuster(adjuster);
    return context ? context.querySelector('form[action*="/cart/add"]') : null;
  }

  function adjusterForForm(form) {
    if (!form) return null;
    var inner = form.querySelector(".qty-adjuster[data-limit]");
    if (inner) return inner;
    var context = form.closest(".toa-product-card-actions,.product-block__inner,.product-block,.product-details");
    return context ? context.querySelector(".qty-adjuster[data-limit]") : null;
  }

  function quantityInputsFor(form, adjuster) {
    var inputs = [];
    if (adjuster) {
      adjuster.querySelectorAll('input[name="quantity"], .qty-adjuster__value').forEach(function (input) {
        if (inputs.indexOf(input) === -1) inputs.push(input);
      });
    }
    if (form) {
      form.querySelectorAll('input[name="quantity"]').forEach(function (input) {
        if (inputs.indexOf(input) === -1) inputs.push(input);
      });
    }
    return inputs;
  }

  function setButtonDisabled(button, disabled) {
    if (!button) return;
    button.disabled = !!disabled;
    button.classList.toggle("toa-stock-buffer-disabled", !!disabled);
    button.setAttribute("aria-disabled", disabled ? "true" : "false");
    var text = button.querySelector(".button-text, .custom_add_to_cart_text");
    if (text) {
      if (!text.getAttribute("data-toa-original-text")) {
        text.setAttribute("data-toa-original-text", text.textContent || "");
      }
      text.textContent = disabled ? "Ausverkauft" : text.getAttribute("data-toa-original-text");
    }
  }

  function setControlState(adjuster, limit, quantity) {
    if (!adjuster) return;
    var down = adjuster.querySelector(".qty-adjuster__down");
    var up = adjuster.querySelector(".qty-adjuster__up");
    if (down) down.disabled = limit <= 0 || quantity <= 1;
    if (up) up.disabled = limit <= 0 || quantity >= limit;
    adjuster.classList.toggle("toa-stock-buffer-empty", limit <= 0);
  }

  function applyOptionInventory(option) {
    if (!option || !option.hasAttribute("data-inventory")) return null;
    if (!option.hasAttribute("data-toa-original-inventory")) {
      option.setAttribute("data-toa-original-inventory", option.getAttribute("data-inventory") || "");
    }
    var limit = sellableLimit(option.getAttribute("data-toa-original-inventory"));
    if (limit == null) return null;
    option.setAttribute("data-inventory", String(limit));
    option.setAttribute("data-toa-buffered-inventory", String(limit));
    return limit;
  }

  function selectedOptionLimit(select) {
    if (!select || !select.options || select.selectedIndex < 0) return null;
    return applyOptionInventory(select.options[select.selectedIndex]);
  }

  function originalLimitForAdjuster(adjuster) {
    if (!adjuster) return null;
    if (!adjuster.hasAttribute("data-toa-original-limit")) {
      adjuster.setAttribute("data-toa-original-limit", adjuster.getAttribute("data-limit") || "");
    }
    return adjuster.getAttribute("data-toa-original-limit");
  }

  function currentBufferedLimit(form, adjuster) {
    var select = form ? form.querySelector('select[name="id"]') : null;
    var selectedLimit = selectedOptionLimit(select);
    if (selectedLimit != null) return selectedLimit;
    return sellableLimit(originalLimitForAdjuster(adjuster));
  }

  function rememberVariantLimit(form, limit) {
    var variantId = variantIdForForm(form);
    if (variantId && limit != null) variantLimits[variantId] = limit;
  }

  function applyFormLimit(form, adjuster) {
    if (!adjuster) adjuster = adjusterForForm(form);
    if (!form) form = formForAdjuster(adjuster);

    var limit = currentBufferedLimit(form, adjuster);
    if (limit == null) return null;

    if (adjuster) {
      adjuster.setAttribute("data-limit", String(limit));
      adjuster.setAttribute("data-toa-buffered-limit", String(limit));
    }

    var inputs = quantityInputsFor(form, adjuster);
    var visibleInput = inputs.find(function (input) { return input.type !== "hidden"; }) || inputs[0] || null;
    var quantity = clampQuantity(visibleInput ? visibleInput.value : "1", limit);
    inputs.forEach(function (input) {
      input.value = String(quantity);
      input.defaultValue = String(quantity);
      input.setAttribute("max", String(limit));
      input.setAttribute("min", limit > 0 ? "1" : "0");
      input.setAttribute("data-toa-buffered-quantity", String(quantity));
    });

    setControlState(adjuster, limit, quantity);
    rememberVariantLimit(form, limit);

    if (form) {
      var addButton = form.querySelector('button[name="add"], button[type="submit"], .product-add');
      setButtonDisabled(addButton, limit <= 0);
      form.classList.toggle("toa-stock-buffer-empty", limit <= 0);
      form.setAttribute("data-toa-stock-buffer-limit", String(limit));
    }

    return { limit: limit, quantity: quantity };
  }

  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('select[name="id"] option[data-inventory]').forEach(applyOptionInventory);
    scope.querySelectorAll(".qty-adjuster[data-limit]").forEach(function (adjuster) {
      applyFormLimit(formForAdjuster(adjuster), adjuster);
    });
  }

  function enforceForm(form) {
    var result = applyFormLimit(form, adjusterForForm(form));
    if (!result) return null;
    return result;
  }

  function clampKnownVariantQuantity(id, quantity) {
    var key = String(id || "").trim();
    var limit = key ? variantLimits[key] : null;
    if (limit == null) return quantity;
    return clampQuantity(quantity, limit);
  }

  function clampUrlEncodedBody(body) {
    var params = new URLSearchParams(body);
    if (params.has("id") && params.has("quantity")) {
      params.set("quantity", String(clampKnownVariantQuantity(params.get("id"), params.get("quantity"))));
    }
    return params.toString();
  }

  function clampJsonBody(text) {
    var payload = JSON.parse(text);
    if (payload && payload.id && payload.quantity != null) {
      payload.quantity = clampKnownVariantQuantity(payload.id, payload.quantity);
    }
    if (payload && Array.isArray(payload.items)) {
      payload.items.forEach(function (item) {
        if (item && item.id && item.quantity != null) {
          item.quantity = clampKnownVariantQuantity(item.id, item.quantity);
        }
      });
    }
    return JSON.stringify(payload);
  }

  function clampBody(body) {
    if (!body) return body;
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      var id = body.get("id");
      if (id && body.has("quantity")) body.set("quantity", String(clampKnownVariantQuantity(id, body.get("quantity"))));
      return body;
    }
    if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
      if (body.has("id") && body.has("quantity")) {
        body.set("quantity", String(clampKnownVariantQuantity(body.get("id"), body.get("quantity"))));
      }
      return body;
    }
    if (typeof body === "string") {
      var text = body.trim();
      if (!text) return body;
      try {
        return text.charAt(0) === "{" ? clampJsonBody(text) : clampUrlEncodedBody(text);
      } catch (error) {
        return body;
      }
    }
    return body;
  }

  function patchFetch() {
    if (typeof window.fetch !== "function" || window.fetch.__toaStockBufferPatched) return;
    var nativeFetch = window.fetch;
    function bufferedFetch(resource, init) {
      var url = typeof resource === "string" ? resource : (resource && resource.url) || "";
      if (init && actionIsCartAdd(url) && init.body) {
        init = Object.assign({}, init, { body: clampBody(init.body) });
      }
      return nativeFetch.call(this, resource, init);
    }
    bufferedFetch.__toaStockBufferPatched = true;
    window.fetch = bufferedFetch;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__toaStockBufferPatched) return;
    var proto = window.XMLHttpRequest.prototype;
    var nativeOpen = proto.open;
    var nativeSend = proto.send;
    proto.open = function (method, url) {
      this.__toaStockBufferCartAdd = actionIsCartAdd(url);
      return nativeOpen.apply(this, arguments);
    };
    proto.send = function (body) {
      return nativeSend.call(this, this.__toaStockBufferCartAdd ? clampBody(body) : body);
    };
    proto.__toaStockBufferPatched = true;
  }

  document.addEventListener("submit", function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    var result = enforceForm(form);
    if (result && result.limit <= 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener("click", function (event) {
    var target = event.target && event.target.closest ? event.target.closest(".qty-adjuster__up,.qty-adjuster__down,button[name='add'],.product-add") : null;
    if (!target) return;
    var form = cartAddFormFromElement(target);
    if (form) enforceForm(form);
    window.setTimeout(function () {
      if (form) enforceForm(form);
      else applyAll(document);
    }, 0);
  }, true);

  document.addEventListener("input", function (event) {
    var input = event.target && event.target.closest ? event.target.closest(".qty-adjuster__value,input[name='quantity']") : null;
    if (!input) return;
    var form = cartAddFormFromElement(input);
    if (form) enforceForm(form);
    else {
      var adjuster = input.closest(".qty-adjuster[data-limit]");
      if (adjuster) applyFormLimit(formForAdjuster(adjuster), adjuster);
    }
  }, true);

  document.addEventListener("change", function (event) {
    var select = event.target && event.target.closest ? event.target.closest('select[name="id"]') : null;
    if (select) window.setTimeout(function () { enforceForm(select.closest('form[action*="/cart/add"]')); }, 0);
  }, true);

  function observe() {
    if (!window.MutationObserver || !document.body) return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        applyAll(document);
      }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function run() {
    patchFetch();
    patchXhr();
    applyAll(document);
    observe();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  window.addEventListener("load", function () { applyAll(document); });
  window.setTimeout(function () { applyAll(document); }, 300);
  window.setTimeout(function () { applyAll(document); }, 1200);
  window.setTimeout(function () { applyAll(document); }, 2600);

  window.__toaSellableStockBuffer = {
    buffer: BUFFER,
    run: function () { applyAll(document); },
    variantLimits: variantLimits
  };
})();
